import axios from "axios";

export function request(config) {

  // 创建axios实例
  const instance = axios.create({
    baseURL: "/",  // 路径
    timeout: 2000
  })

  // 发送真正的网络请求
  return instance(config)
}